/* eslint-disable */
import React from 'react';
import FormInput from 'partial/form/FormInput';
import { showDrawer } from 'partial/components/Modal';
import { HiOutlineMail } from 'react-icons/hi';
import Form from 'partial/form/Form';
import Button from 'partial/components/Button';
import FormPassword from 'partial/form/FormPassword';
import ForgotPasswordModal from '../modals/ForgotPasswordModal';
import { useLogin } from '../hooks';

function Login() {
  const [form, setForm] = React.useState({
    email: '',
    password: '',
  });
  const [isLoading, submit] = useLogin();
  const handleForgotPassword = (e) => {
    e.preventDefault();
    showDrawer({
      title: 'Forgot Password',
      align: 'justify-center',
      size: 'sm',
      content: (onClose) => (
        <ForgotPasswordModal email={form.email} onClose={onClose} />
      ),
    });
  };

  const handleSubmit = () => {
    submit(form, () => {});
  };
  return (
    <Form onSubmit={handleSubmit}>
      <div className="mb-3">
        <FormInput
          icon={HiOutlineMail}
          name="email"
          onChange={setForm}
          value={form.email}
          label="Email Address"
          placeholder="user@email.com"
          type="email"
          required
        />
      </div>
      <div className="mb-3">
        <FormPassword
          name="password"
          onChange={setForm}
          value={form.password}
          label="Password"
          placeholder="••••••"
          required
        />
      </div>
      <Button
        size="xl"
        primary
        type="submit"
        className="w-full text-white"
        disabled={isLoading}
      >
        Login
      </Button>
      {/* <div className="font-semibold mt-10 text-center">
        <a
          className="text-gray-600 border-b border-dashed border-gray-300"
          href="/"
          onClick={handleForgotPassword}
        >
          Forgot Password
        </a>
      </div> */}
      <div className="text-xs font-light mt-10 text-center text-gray-500">
        &copy; 2025 eFPS v1.0
      </div>
    </Form>
  );
}

Login.propTypes = {};

export default Login;
